/* eslint-disable */
let marketId = 28
export default {
  param_SYMBOLS: {
    "fid":"marketdetail-req",
    "symbol":[],
    "marketId":marketId
  },
  param_tradeTop: {
    'fid': 'marketdetail-req',
    'symbol': '',
    'orderBy': 'symbol',
    'direction': 'asc',
    'marketId': marketId
  },
  param_tradeBottom: {
    'fid': 'marketdetail-req',
    'symbol': '',
    'orderBy': 'symbol',
    'direction': 'desc',
    'marketId': marketId
  },
  param_priceTop: {
    'fid': 'marketdetail-req',
    'symbol': '',
    'orderBy': 'close',
    'direction': 'asc',
    'marketId': marketId
  },
  param_priceBottom: {
    'fid': 'marketdetail-req',
    'symbol': '',
    'orderBy': 'close',
    'direction': 'desc',
    'marketId': marketId
  },
  param_UpDownTop: {
    'fid': 'marketdetail-req',
    'symbol': '',
    'orderBy': 'quotechange',
    'direction': 'asc',
    'marketId': marketId
  },
  param_UpDownBottom: {
    'fid': 'marketdetail-req',
    'symbol': '',
    'orderBy': 'quotechange',
    'direction': 'desc',
    'marketId': marketId
  },
  param_amountTop: {
    'fid': 'marketdetail-req',
    'symbol': '',
    'orderBy': 'amount',
    'direction': 'asc',
    'marketId': marketId
  },
  param_amountBottom: {
    'fid': 'marketdetail-req',
    'symbol': '',
    'orderBy': 'amount',
    'direction': 'desc',
    'marketId': marketId
  },
  //  top
  param_top: {
    'fid': 'subscribe-req',
    'subscribeType':'top',
    'symbol': '100001',
    // 'depth': 0,
    'topNum': 6
  },
  //  取消大单筛选
  param_unsubscribereq: {
    'fid': 'unsubscribe-req',
    'subscribeType':'data',
    'contractIds': []
  },
  // 大单筛选订阅
  param_big_top: {
    'fid': 'subscribe-req',
    'subscribeType':'data',
    'symbol': '100001',
    // 'depth': 0,
    'singleQuantity': ''
  },
   //  toporder 订单转让时使用订阅
   param_toporder: {
    'fid': 'subscribe-req',
    'subscribeType':'topOne',
    'symbol': '',
  },
   // order 行情简报
   param_businessJb: {
    'fid': 'BusinessRequest',
    'marketId':marketId,
  },
   //  toporder 订单转让时使用 取消
   param_untoporder: {
    'fid': 'unsubscribe-req',
    'subscribeType':'topOne',
    'contractIds': [],
  },
  //  实时成交
  param_realtime: {
    'fid': 'pricedetail-req',
    'singleQuantity': '',
    'marketId': 111,
    'contractId': '',
    'bCtrl': 1,
    'positionIndex': -500,
    'count': 500
  },
  //  订阅
  param_subscribe: {
    'fid': 'subscribe-req',
    "subscribeType":"market",
    'contractIds': []
  },

  // 定义socket请求挂牌参数
  param_contract: {
    'fid': 'contract-req',
    'marketId': ''
  },
  // 定义市场最新报价参数
  param_price: {
    'fid': 'lpmkt-req',
    'marketId': ''
  },
  //  param_subscribe: {
  //      "fid": "subscribe-req",
  //      "contractIds": []
  //  }

  // 搜索
  param_searchCurrency: {
    'fid': 'marketdetail-req',
    'symbol': ['search'],
    "marketId":marketId
  },
  /** 分数图数据 start**/
  // 分时图订阅数据
  param_currencytimeline: {
    "fid": "currencytimeline-req",
    "contractId": null, // 243
    "timeFlag": 0
  }, 
  // 分时图取消订阅数据
  param_unsubscribe:{
    contractIds: [],
    fid: "unsubscribe-req",
    subscribeType: "timeLine"
  },
  /** 分数图数据 end**/
  // 取消所有订阅
  param_unssAll:{
    fid: "unsubscribe-req",
    subscribeType: "all"
  },
}
